import React from "react";
import { Button } from "aible";

import MarketTile from "components/Market/MarketTile/MarketTile";
import MarketSidebar from "components/Market/MarketSidebar/MarketSidebar";

import styles from "./style.module.css";

const MarketJobs = (props) => {
  const { type, updateIsCreateJob, hideSearch } = props;

  const renderGridTilesOld = () => {
    const consultantData = [
      { title: "Hugh Mungus", subtitle: "Data Scientist / USA" },
      { title: "Al E. Gater", subtitle: "Marketing Analyst / USA" },
      { title: "Ben Dover", subtitle: "Data Analyst / USA" },
      { title: "Jay Walker", subtitle: "Data Engineer / USA" },
      { title: "Dinah Mite", subtitle: "Data Scientist / USA" },
      { title: "Gerry Atrick", subtitle: "Data Scientist / USA" }
    ];

    const jobData = [
      { title: "Software Engineer", subtitle: "Aible" },
      { title: "Software Engineer", subtitle: "Aible" },
      { title: "Software Engineer", subtitle: "Aible" },
      { title: "Software Engineer", subtitle: "Aible" },
      { title: "Software Engineer", subtitle: "Aible" },
      { title: "Software Engineer", subtitle: "Aible" },
      { title: "Software Engineer", subtitle: "Aible" },
      { title: "Software Engineer", subtitle: "Aible" },
      { title: "Software Engineer", subtitle: "Aible" },
      { title: "Software Engineer", subtitle: "Aible" },
      { title: "Software Engineer", subtitle: "Aible" }
    ];

    const dataToUse = type === "hire consultants" ? consultantData : type === "job postings" ? jobData : [];
    const numberToAdd = dataToUse.length % 3;
    if (numberToAdd === 1) {
      dataToUse.push({});
    } else if (numberToAdd === 2) {
      dataToUse.push({});
      dataToUse.push({});
    }
    return (
      <div className={styles.gridTilesTable}>
        {dataToUse.map((dataItem, index) => {
          if (dataItem.title) {
            return (
              <div key={index} className={styles.gridTilesTableColumn}>
                <MarketTile data={dataItem} type={type} />
              </div>
            );
          }
          return (
            <div key={index} className={styles.gridTilesTableColumn}>
              {" "}
            </div>
          );
        })}
      </div>
    );
  };

  const renderGridTiles = () => {
    const { jobs, updateHireJob, updateIsCreateJob, deleteJob } = props;
    return (
      <div className={styles.gridTilesTable}>
        {jobs.map((job, index) => {
          return (
            <div key={index} className={styles.gridTilesTableColumn}>
              <MarketTile
                data={job}
                type={type}
                updateHireJob={updateHireJob}
                updateIsCreateJob={updateIsCreateJob}
                deleteJob={deleteJob}
              />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <React.Fragment>
      {hideSearch !== true && <MarketSidebar type={type} buttonOnClick={updateIsCreateJob} />}
      <div className={styles.consultantsMainContainer}>
        <div className={styles.mainContainerHeader}>Recent Job Postings</div>
        <div>{renderGridTiles()}</div>
      </div>
    </React.Fragment>
  );
};

export default MarketJobs;
